import * as React from 'react'
import { ReactSearchAutocomplete } from 'react-search-autocomplete';

interface Props {
    send: (msg: string, payload: string) => void
    buttonData: {
        text: string
        subtext: string
        img: URL | string
        payload: string
        custom: any
    }
    setButtons: (buttons: Array<any>) => void
}

type item = {
    id: number
    name: string
}

export const FuzzySearch: React.FC<Props> = ({ send, buttonData, setButtons }: Props) => {
    const localAuthList = buttonData.custom.localAuths.map(
        (auth: string, i: number) => (
          {
            id: i,
            name: auth,
          }
        ),
      )

    const formatResult = (item: item) => (<p dangerouslySetInnerHTML={{ __html: `<p>${item.name}</p>` }} />)

    const handleOnSelect = (item: item) => {
        send(item.name, buttonData.payload)
        setButtons([])
    }

    return (
        <div className="fuzzySearch">
            <ReactSearchAutocomplete
                items={localAuthList}
                onSelect={handleOnSelect}
                autoFocus
                formatResult={formatResult}
                maxResults={5}
                placeholder="Search here..."
                styling={{
                    boxShadow: 'none',
                    borderRadius: '10px',
                }}
            />
        </div>
    )
}